import { API_BASE_URL } from "../../../config/apiConfig";
// src/services/travelInterestsApi.js
import axios from 'axios';
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

export const InterestsApi = {
  // Get all available travel interests
  getAllTravelInterests: async (token) => {
    try {
      const response = await api.get('/travel-interests', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      // console.log('User Travel Interests:', response.data);
      return response.data;
    } catch (error) {
      // console.error('Get Travel Interests Error:', error.response?.data);
      throw error;
    }
  },

  // Get user's current travel interests
  getUserTravelInterests: async (token) => {
    try {
      const response = await api.get('/user/travel-interests', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      // console.log('User Travel Interests:', response.data);
      return response.data;
      
    } catch (error) {
      // console.error('Get User Travel Interests Error:', error.response?.data);
      throw error;
    }
  },

  // Update user travel interests (PUT - replaces all)
  updateUserTravelInterests: async (interests, token) => {
    try {
      // console.log('Updating travel interests:', interests);
      
      const requestBody = {
        interests: interests
      };
      
      const response = await api.put('/user/travel-interests', 
        requestBody,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Update Travel Interests API Error:', error.response?.data);
      throw error;
    }
  },

  // Add user travel interests (POST - adds new ones)
  addUserTravelInterests: async (interests, token) => {
    try {
      console.log('Adding travel interests:', interests);
      
      const requestBody = {
        interests: interests
      };
      
      const response = await api.post('/user/travel-interests', 
        requestBody,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Add Travel Interests API Error:', error.response?.data);
      throw error;
    }
  },
};

export default InterestsApi;